import { render, staticRenderFns } from "./AssetImageLinkCreateScreen.vue?vue&type=template&id=71f41b8a&"
import script from "./AssetImageLinkCreateScreen.vue?vue&type=script&lang=js&"
export * from "./AssetImageLinkCreateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports